import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
} from '@windmill/react-ui';
import { Tabs, Tab } from '@mui/material';
import { notifyError } from 'utils/toast';
import AdvertisementTable from 'components/advertisement/AdvertisementTable';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useFilter from 'hooks/useFilter';
import { useState, useEffect, useContext } from 'react';
import AdvertisementServices from 'services/AdvertisementServices';
import AdvertisementDrawer from 'components/drawer/AdvertisementDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import { SidebarContext } from 'context/SidebarContext';
import DataWrapper from './DataWrapper';
import { FiRefreshCcw } from 'react-icons/fi';
import sidebar from 'routes/sidebar';

const Advertisement = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	// const { data, loading } = useAsync(AdvertisementServices.getAdvertisementList);
	//const advertisement = data?.data || [];
	const [loading, setLoading] = useState(false);
	const { isUpdate, setIsUpdate } = useContext(SidebarContext);
	const { title, serviceId } = useToggleDrawer();
	const [itemsPerPage,setItemsPerPage] = useState(10);
	const [status, setStatus] = useState('');
	const [error, setError] = useState('');
	const [tab, setTab] = useState(0);
	const [advertisementData, setAdvertisementData] = useState([]);
	// const hideView = adminInfo?.permission?.some(
	//   (perm) => perm.id_tab === "advertisement" && perm.view === 1
	// );
	// const hideEdit = adminInfo?.permission?.some(
	//   (perm) => perm.id_tab === "advertisement" && perm.edit === 1
	// );
	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'advertisement' && perm.view === 1
		  );
	const hideEdit = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'advertisement' && perm.edit === 1
		  );

	const {
		advertisementRef,
		dataTable,
		serviceData,
		handleSubmitAdvertisement,
		currentPage,
	} = useFilter(advertisementData, itemsPerPage);
	    useEffect(() => {
    if (dataTable.length !== 0) {
      setItemsPerPage(dataTable.length);
    }
  }, [dataTable]);

	useEffect(() => {
		const fetchAdvertisement = async () => {
			try {
				setLoading(true);
				let response;
				if (tab === 0) {
					response = await AdvertisementServices.getAllAdvertisement();
				} else if (tab === 1) {
					response = await AdvertisementServices.getAllAdvertisementtwo();
				}

				// Log the response to inspect its structure
				setStatus(response?.status);
				// Check if response.data is an array or an object
				if (Array.isArray(response?.data)) {
					// Handle case when response.data is an array
					const updatedData = response.data.map(
						({ id, title, url, content, ...rest }) => ({
							id,
							title,
							url, // Renaming for clarity
							content, // Renaming for clarity
							...rest,
						})
					);
					setAdvertisementData(updatedData);
				} else if (response?.data && typeof response?.data === 'object') {
					// Handle case when response.data is a single object
					const updatedData = [
						{
							id: response.data.id,
							title: response.data.title,
							url: response.data.url,
							content: response.data.content,
							...response.data, // Spread the rest of the object if needed
						},
					];
					setAdvertisementData(updatedData);
				}
				//  else {
				//   // Handle unexpected data format
				//   console.error("Unexpected data format:", response?.data);
				//   notifyError("Data format error. Please try again later.");
				// }
			} catch (error) {
				console.error('Error fetching advertisement:', error);
				setError(true);
				notifyError('Failed to fetch advertisement. Please try again later.');
			} finally {
				// Set loading state to false after API call is complete
				setLoading(false);
			}
		};
		fetchAdvertisement();
		setIsUpdate(false);
		// eslint-disable-next-line
	}, [tab, isUpdate]);

	const handleTabChange = (event, newValue) => {
		setTab(newValue);
	};

	const handleRefresh = () => {
		setIsUpdate(true);
	};
	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />
					<MainDrawer>
						<AdvertisementDrawer id={serviceId} />
					</MainDrawer>
					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
						<CardBody>
							<div
								style={{ width: '600px' }}
								className="flex items-center gap-6"
							>
								<Input
									ref={advertisementRef}
									className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
									type="search"
									name="search"
									autoComplete="off"
									placeholder="Quick Search"
									onChange={handleSubmitAdvertisement}
								/>
								<FiRefreshCcw
									onClick={() => {
										handleRefresh();
									}}
									cursor="pointer"
								/>
							</div>
						</CardBody>
					</Card>
					<Tabs
						value={tab}
						onChange={handleTabChange}
						TabIndicatorProps={{
							style: { backgroundColor: '#057a55' },
						}}
					>
						<Tab
							className="focus:outline-none dark:text-white"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="Ads 1"
						/>
						<Tab
							className="focus:outline-none dark:text-white"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="Ads 2"
						/>
					</Tabs>
					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length ? (
							<TableContainer className="mb-8">
								<Table>
									<TableHeader className="custom-table-header capitalize">
										<tr>
											<TableCell className="text-center">Sl.No.</TableCell>
											<TableCell className="text-center">Title</TableCell>
											<TableCell className="text-center">URL </TableCell>
											<TableCell className="text-center">Image</TableCell>
											<TableCell className="text-center">Actions</TableCell>
										</tr>
									</TableHeader>

									<AdvertisementTable
										advertisement={dataTable}
										perpage={itemsPerPage}
										currentPage={currentPage}
										tab={tab}
										hideEdit={hideEdit}
									/>
								</Table>
								{/* <TableFooter>
            <Pagination
              totalResults={totalResults}
              resultsPerPage={resultsPerPage}
              onChange={handleChangePage}
              label="Table navigation"
            />
          </TableFooter> */}
							</TableContainer>
						) : (
							<NotFound title="There are no Advertisements." />
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default Advertisement;
